// 导入封装好的 axios 实例
import request from '@/utils/request'


//用户列表接口
export function accountList(data) {
    return request({
        url: '/sys/account/page',
        method: 'post',
        data
    })
}

export function findAccount(id) {
    return request({
        url: `/sys/account/getById?accountId=${id}`,
        method: 'get',
    })
}

// 模糊查询用户
export function likeAccount(keyword) {
    return request({
        url: `/sys/account/likeAccount?keyword=${keyword}`,
        method: 'get',
    })
}

export function fetchOfficeUser(keyword) {
    return request({
        url: `/sys/account/officeUser?keyword=${keyword}`,
        method: 'get',
    })
}

// 新增用户
export function saveAccount(data) {
    return request({
        url: '/sys/account/save',
        method: 'post',
        data
    })
}

// 编辑用户
export function updateAccount(data) {
    return request({
        url: '/sys/account/update',
        method: 'post',
        data
    })
}

// 删除用户
export function deleteAccountById(id) {
    return request({
        url: `/sys/account/delete/${id}`,
        method: 'delete',
    })
}

// enable用户
export function enableAccountById(id) {
    return request({
        url: `/sys/account/enable/${id}`,
        method: 'put',
    })
}

// 查询用户的权限
export function getUserPermissions(id) {
    return request({
        url: `/sys/account/getPermission?accountId=${id}`,
        method: 'get',
    })
}

// 保存或者修改用户权限
export function saveOrUpdateUserPermissions(data) {
    return request({
        url: `/sys/account/saveOrUpdatePermission`,
        method: 'put',
        data
    })
}


// 角色
export function roleList(data) {
    return request({
        url: '/sys/sys-role/page',
        method: 'post',
        data
    })
}

export function saveOrUpdateRole(data) {
    return request({
        url: '/sys/sys-role/saveOrUpdate',
        method: 'post',
        data
    })
}

//删除角色
export function deleteRoleById(id) {
    return request({
        url: `/sys/sys-role/delete/${id}`,
        method: 'delete',
    })
}

// 根绝用户获取角色id
export function getRoleIdByUserId(id) {
    return request({
        url: `/sys/sys-role/getRole/${id}`,
        method: 'get',
    })
}
// 绑定角色id
export function bindRoleForUser(data) {
    return request({
        url: '/sys/sys-role/userBindRole',
        method: 'post',
        data
    })
}

// 资源
export function resourceList() {
    return request({
        url: '/sys/sys-right/menus',
        method: 'get'
    })
}
// 资源
export function pageResource(data) {
    return request({
        url: '/sys/sys-right/page',
        method: 'post',
         data
    })
}


export function saveOrUpdateResource(data) {
    return request({
        url: '/sys/sys-right/saveOrUpdate',
        method: 'post',
        data
    })
}

// 删除
export function deleteResource(id) {
    return request({
        url: `/sys/sys-right/delete/${id}`,
        method: 'delete',
    })
}

export function allResource(clientType,bizLine) {
    return request({
        url: `/sys/sys-right/resource?clientType=${clientType}${bizLine ? `&bizLine=${bizLine}`: '' }`,
        method: 'get',
    })
}

// 根据角色id获取绑定的资源
export function getRoleResource(id) {
    return request({
        url: `/sys/sys-right/getByRole/${id}`,
        method: 'get',
    })
}
// 绑定资源
export function bindResource(data) {
    return request({
        url: '/sys/sys-right/saveRoleRef',
        method: 'post',
        data
    })
}
// 获取权限列表
export function pagePermission(data) {
    return request({
        url: '/sys/dataPermission/page',
        method: 'post',
        data
    })
}

export function saveOrUpdatePermission(data) {
    return request({
        url: '/sys/dataPermission/saveOrUpdate',
        method: 'post',
        data
    })
}

export function deletePermissionById(id) {
    return request({
        url: `/sys/dataPermission/delete/${id}`,
        method: 'delete',
    })
}

// 查询用户与企业的关联
export function getUserOfficeRef(id) {
    return request({
        url: `/sys/sys-account-rel-office/account/${id}`,
        method: 'get',
    })
}

// 绑定用户与企业
export function bindUserOffice(data) {
    return request({
        url: '/sys/sys-account-rel-office/bind',
        method: 'post',
        data
    })
}

// 新建代理商
export function createAgent(data){
    return request({
        url: '/sys/agent/save',
        method: 'post',
        data
    })
}

// 更新代理商
export function updateAgent(data){
    return request({
        url: '/sys/agent/update',
        method: 'put',
        data
    })
}


// 根据id查询代理商
export function getAgentById(id) {
    return request({
        url: `/sys/agent/index/${id}`,
        method: 'get',
    })
}

// 代理商生效
export function enableAgentById(id) {
    return request({
        url: `/sys/agent/available/${id}`,
        method: 'put',
    })
}

// 删除代理商
export function deleteAgentById(id) {
    return request({
        url: `/sys/agent/delete/${id}`,
        method: 'delete',
    })
}
// 代理商分页列表
export function agentPage(data) {
    return request({
        url: '/sys/agent/page',
        method: 'post',
        data
    })
}

// 模版分页
export function permissionTemplatePage(data) {
    return request({
        url: '/sys/permission/template/page',
        method: 'post',
        data
    })
}

// 新增模版
export function permissionTemplateSave(data) {
    return request({
        url: '/sys/permission/template',
        method: 'post',
        data
    })
}

// 更新模版
export function permissionTemplateUpdate(data) {
    return request({
        url: '/sys/permission/template',
        method: 'put',
        data
    })
}

 // 删除模版
export function permissionTemplateDelete(id) {
    return request({
        url: `/sys/permission/template?id=${id}`,
        method: 'delete',
    })
}


